module.exports = __webpack_public_path__ + "static/media/43_B.d40f1d06.png";